module.exports = __webpack_public_path__ + "static/media/civil.18647ca2.svg";